module.exports = __webpack_public_path__ + "static/media/18_plantilla_rec_combo_simple_cp_isotonicas_lata_473_monster_white.334c9a70.png";